import { IComponentContext, IOmniaCommand, IVariety } from "../../exports";
import { ISeedRatePlan } from "../../types";

export class EditPlanCmd implements IOmniaCommand {

    plan: ISeedRatePlan;

    canExecute: (target: any) => boolean;
    execute: (target: any) => void;

    constructor(private ctxt: IComponentContext, public text?: string, public icon?: string) {
    }


    editPlan(plan: ISeedRatePlan) {

        this.plan = plan;

        this.ctxt.startComponent({ component: "omnia-seeds-plan-edit", execArguments: this });

    }

}
